export default __webpack_public_path__ + "static/media/avatar-s-9.b1abeefc.jpg";